"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../types/General");
const entryVarEvaluateEntries = async ({ entriesEntryVar, evaluateEntryVar, }) => {
    const entries = entriesEntryVar[General_1.DEFINITION_PROP_NAMES.ENTRIES];
    if (!entries) {
        return [];
    }
    return Promise.all(entries.map(async (entry) => Promise.all(entry
        .map((entryItem) => (entryItem ? evaluateEntryVar(entryItem) : undefined)))));
};
exports.default = entryVarEvaluateEntries;
